<template>
  <div v-if="loading" class="spinner-container">
    <ProgressSpinner style="width:30px;height:30px" strokeWidth="6" />
  </div>
  <div v-else-if="imageUrl">
    <ImagePreview v-if="fileType && fileType.startsWith('image/')"
      :src="imageUrl"
      :alt="alt"
      preview
      :height="height"
      class="p-2"
    />

    <embed
      v-else-if="fileType === 'application/pdf'"
      :id="'pdf-viewer_' + id"
      :src="imageUrl"
      type="application/pdf"
      width="100%"
      :height="height + 'px'"
      frameborder="0"
    />

    <video
      :id="id"
      v-else-if="fileType && fileType.startsWith('video/')"
      :src="imageUrl"
      :height="height + 'px'"
      controls
      class="p-2"
    >
    </video>
  </div>
  <div v-else class="placeholder-container">
    <i class="pi pi-image"></i>
  </div>
</template>

<script>
import filesService from '../../services/files.service';
import ProgressSpinner from 'primevue/progressspinner';

export default {
  name: "AuthenticatedImage",
  components: { ProgressSpinner },
  props: {
    file: {
      type: [Object, String],
      required: true
    },
    id: {
      type: [Number, String],
      required: false,
      default: () => `auth-image-${Math.random().toString(36).slice(2, 9)}`
    },
    alt: {
      type: String,
      default: 'Imagem'
    },
    height: {
      type: String,
      default: '50'
    },
    fileServiceMethod: {
      type: String,
      required: false,
      default: 'getSparsFile'
    }
  },
  data() {
    return {
      loading: false,
      imageUrl: null,
      fileType: null
    };
  },
  watch: {
    file: {
      immediate: true,
      handler(newFile) {
        this.loadImage(newFile);
      }
    }
  },
  methods: {
    async loadImage(fileToLoad) {
      if (fileToLoad == null) {
        return;
      }

      if (this.imageUrl) {
        URL.revokeObjectURL(this.imageUrl);
        this.imageUrl = null;
      }

      let fileName;

      if (typeof fileToLoad === 'string') {
        fileName = fileToLoad;
      } else if (fileToLoad && typeof fileToLoad === 'object' && fileToLoad.file_name) {
        fileName = fileToLoad.file_name;
      } else {
        return;
      }

      this.loading = true;
      try {
        const imageBlob = await filesService[this.fileServiceMethod](fileName);
        if (imageBlob) {
          this.imageUrl = URL.createObjectURL(imageBlob);
          this.fileType = imageBlob.type;
        }
      } catch (error) {
        console.error("Failed to load authenticated image:", error);
      } finally {
        this.loading = false;
      }
    }
  },
  beforeDestroy() {
    if (this.imageUrl) {
      URL.revokeObjectURL(this.imageUrl);
    }
  }
};
</script>

<style scoped>
.spinner-container, .placeholder-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background-color: #f0f0f0;
  border-radius: 4px;
}
</style>